import React from "react";
import { Divider, useTheme } from "@mui/material";
import MuiCard, { CardProps } from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Skeleton from "@mui/material/Skeleton";

interface Props {
  title: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
}

export function Card(props: Props & CardProps) {
  const theme = useTheme();
  const { title, action, children, loading, ...rest } = props;

  const card = (
    <MuiCard variant="outlined" {...rest}>
      <CardHeader
        sx={{ backgroundColor: theme.palette.lightBackground.main }}
        title={props.title}
        titleTypographyProps={{ variant: "subtitle1" }}
        action={props.action}
      />
      <Divider />
      <CardContent sx={{ backgroundColor: theme.palette.lightBackground.light }}>{props.children}</CardContent>
    </MuiCard>
  );

  if (props.loading)
    return (
      <Skeleton variant="rectangular" width="100%">
        {card}
      </Skeleton>
    );
  else return card;
}
